import React from "react";
import { Link } from "react-router-dom";

const ActionButtons = ({ startRequest, onSubmit, t }) => {
  return (
    <div className="kt-portlet__foot">
      <div className="kt-form__actions text-right">
        {!startRequest ? (
          <button type="submit" onClick={onSubmit} className="btn btn-primary">
            {t("Enregistrer")}
          </button>
        ) : (
          <button
            className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
            type="button"
            disabled
          >
            {t("Chargement")}...
          </button>
        )}

        <Link
          to="/dashboard"
          className={`btn btn-secondary mx-2 ${startRequest ? "disabled" : ""}`}
          style={startRequest ? { pointerEvents: "none", opacity: 0.6 } : {}}
        >
          {t("Quitter")}
        </Link>
      </div>
    </div>
  );
};

export default ActionButtons;
